import React, { useRef, useState } from 'react'
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = () => {
    const captchaRef = useRef(null);
    const [isCaptchaCompleted, setIsCaptchaCompleted] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");

    const handleCaptchaChange = (token:any) => {
        setCaptchaToken(token);
        setIsCaptchaCompleted(true);
    };

    const handleSubmit = () => {
        // Usually send token to your backend
        console.log("Submitting with token:", captchaToken);
    };

    return (
        <div>
            <h2>Verify you're human</h2>
            <ReCAPTCHA
                sitekey="6LeLj44rAAAAABglHpujawebXLeRUsn1c23kY45y"
                ref={captchaRef}
                onChange={handleCaptchaChange}
            />
            <br />
            <button onClick={handleSubmit} disabled={!isCaptchaCompleted}>
                Submit
            </button>
        </div>
    );
};

export default Captcha;
